import ChartBarIcon from '@heroicons/react/24/solid/ChartBarIcon';
import { SvgIcon } from '@mui/material';
import type { NavEntryGroup, NavEntryItem } from '@starjack/layout';
import { ArrowTrendingUpIcon } from '@heroicons/react/24/solid';
import { Permission } from '@/models/user';
import { useTranslation } from 'react-i18next';

export type B2bNavEntryItem = Omit<NavEntryItem, 'permissionsRequired'> & {
    permissionsRequired: Permission[];
};
export type B2bNavEntryGroup = Omit<NavEntryGroup, 'entries'> & {
    entries: B2bNavEntryItem[];
};
export type B2bSidebarItem = B2bNavEntryGroup | B2bNavEntryItem;

export const useSidebarItems = (): B2bSidebarItem[] => {
    const { t } = useTranslation();

    return [
        {
            title: t('sidebar.dashboard'),
            icon: (
                <SvgIcon fontSize='small'>
                    <ChartBarIcon />
                </SvgIcon>
            ),
            entries: [
                {
                    title: t('sidebar.b2b'),
                    path: '/dashboard/b2b',
                    icon: null,
                    permissionsRequired: [Permission.STATISTIC_NAV],
                    exact: true,
                },
            ],
        },
        {
            title: t('sidebar.sales'),
            icon: (
                <SvgIcon fontSize='small'>
                    <ArrowTrendingUpIcon />
                </SvgIcon>
            ),
            entries: [
                {
                    title: t('sidebar.tickets'),
                    path: '/tickets',
                    icon: (
                        <SvgIcon fontSize='small'>
                            <ChartBarIcon />
                        </SvgIcon>
                    ),
                    permissionsRequired: [],
                    exact: true,
                },
                {
                    title: t('sidebar.orderTickets'),
                    path: '/ticket-bestellen',
                    icon: (
                        <SvgIcon fontSize='small'>
                            <ChartBarIcon />
                        </SvgIcon>
                    ),
                    permissionsRequired: [],
                    exact: true,
                },
            ],
        },
    ];
};
